import gql from 'graphql-tag';
export const footballStatFragment = gql `
  fragment FootballStats on FootballStats {
    corners
    fouls
    goals
    offsides
    penaltiesMissed
    penaltiesAwarded
    freeKicks
    possession
    redCards
    yellowCards
    shotsOnTarget
    shotsOffTarget
    totalShots
    substitutions
    possession
  }
`;
//# sourceMappingURL=FootballStats.js.map